import { ItemProp, ItemType } from '@cox/core-ui8/dist/Accordion'

export const getEnableFAQItems = (enableFAQs: boolean) => {
  const enableFAQsPageElement = enableFAQs && {
    itemScope: true,
    itemType: ItemType.PAGE
  }

  const enableFAQsQuestionElement = enableFAQs && {
    itemScope: true,
    itemProp: ItemProp.MAIN_ENTITY,
    itemType: ItemType.QUESTION
  }

  const enableFAQsNameElement = enableFAQs && {
    itemProp: ItemProp.NAME
  }

  const enableFAQsAnswerElement = enableFAQs && {
    itemScope: true,
    itemProp: ItemProp.ACCEPTED_ANSWER,
    itemType: ItemType.ANSWER
  }

  const enableFAQsTextElement = enableFAQs && {
    itemProp: ItemProp.TEXT
  }
  return {
    enableFAQsNameElement,
    enableFAQsTextElement,
    enableFAQsPageElement,
    enableFAQsQuestionElement,
    enableFAQsAnswerElement
  }
}
